import { BASIC_PORTAL_AUTHORIZATION, TOKEN_URL } from "@/utils/apiUrls";
import { createReferenceId } from "@/utils/initializeSentry";

/**
 * OAuth client-credentials token for portal-scoped auth endpoints.
 */
export const fetchPortalAccessToken = async (): Promise<string> => {
  const response = await fetch(
    `${TOKEN_URL.toString()}?grant_type=client_credentials&scope=all`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: BASIC_PORTAL_AUTHORIZATION,
        "X-Reference-Id": createReferenceId(),
      },
    },
  );

  if (!response.ok) {
    throw new Error(`Portal token request failed: ${response.status}`);
  }

  const data = await response.json();

  if (!data.access_token) {
    throw new Error("Portal token response missing access_token");
  }

  return data.access_token;
};
